import React from 'react';
import Footer from '../components/Footer';

// Angelcam public embed for the Turtle Sunset "SOUTH" cam (Vanderbilt Beach,
// Naples — same beach as LaPlaya, looking south). Unlike the old LaPlaya page
// embed, Angelcam's player sends no frame-ancestors restriction, so it can be
// embedded on any site.
const CAM_EMBED_URL = 'https://v.angelcam.com/iframe?v=17ldm21mle&autoplay=1';

export default function LiveBeachCam() {
  return (
    <div className="site-wrapper">
      <div className="rsvp-bg-photo" style={{ backgroundImage: "url('/Sign in Page.jpeg')" }} />
      <div className="rsvp-bg-overlay" />

      <div className="page-content" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '40px 40px 80px' }}>
          <h2 style={{
            fontFamily: 'var(--font-script)',
            fontSize: '60px',
            fontWeight: 400,
            color: 'var(--green-dark)',
            textAlign: 'center',
            marginBottom: '8px',
            lineHeight: 1.2,
          }}>Live Beach Cam</h2>

          {/* Responsive 16:9 player */}
          <div style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
            background: '#000',
          }}>
            <iframe
              src={CAM_EMBED_URL}
              title="Vanderbilt Beach Live Cam"
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </div>

          <p style={{
            textAlign: 'center',
            marginTop: '24px',
            fontFamily: 'var(--font-serif)',
            fontSize: '1.1rem',
            color: 'var(--green-dark)',
            fontStyle: 'italic',
            lineHeight: 1.6,
          }}>
            Live from Naples, can't wait for this beach to be filled with our favorite people — see you in October!
          </p>

        </div>
      </div>
      <Footer />
    </div>
  );
}
